import { apiFetch } from "./api";

export function getOnboarding() {
  return apiFetch("/merchant/onboarding");
}

export function updateOnboarding(data) {
  return apiFetch("/merchant/onboarding", {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}